module.exports = __webpack_public_path__ + "static/media/transitions2.afdc97a8.gif";